module.exports = __webpack_public_path__ + "img/XT-ConsumiblesTipoMiller.6a56b617.png";